import { SubRegionCrud } from '@/utils/interfaces'
import { TranslateResult } from 'vue-i18n'

export const namespaced = true

export interface message {
  text: string | TranslateResult
  title: string | TranslateResult
  color: string | TranslateResult
  icon: string | TranslateResult
  description: string | TranslateResult
}

interface NotificationsState {
  messages: message[]
  snack: boolean
  snackMessage: {} | message
}

export const state = {
  messages: [] as message[],
  snack: false,
  snackMessage: {} as {} | message,
} as NotificationsState

export const mutations = {
  displayMessage: (state: NotificationsState, payload: message): void => {
    state.snackMessage = payload
    state.snack = true
  },
  pushMessage: (state: NotificationsState, payload: message): void => {
    state.messages.push(payload)
    mutations.displayMessage(state, payload)
  },
  silentMessages: (state: NotificationsState, payload: message[]): void => {
    state.messages.push(...payload)
  },
  removeMessage: (state: NotificationsState, payload: message): void => {
    const index = state.messages.indexOf(payload)
    if (index !== -1) {
      state.messages.splice(index, 1)
    }
  },
  clearMessages: (state: NotificationsState): void => {
    state.messages = []
  },
  snack: (state: NotificationsState, payload: boolean): void => {
    state.snack = payload
  },
}

export const getters = {
  messages: (state: NotificationsState) => state.messages,
  snackMessage: (state: NotificationsState) => state.snackMessage,
  snack: (state: NotificationsState) => state.snack,
}

export const actions = {}
